/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Fragment } from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography, Typography2, breakpoints } from '@coursera/cds-core';

import ConfettiSVG from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/ConfettiSVG';
import LevelSetsResultBody from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelSetsResultBody';
import type { PostLevelSetResults } from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelSetsResultDataProvider';

import _t from 'i18n!nls/program-skills-objectives';

type Props = {
  skillId: string;
  userId: number;
  skillName: string;
  skillScore: number;
  levelsetResults: PostLevelSetResults;
  onCloseUpdatedModal: () => void;
};

const LevelSetsResultContent = ({
  userId,
  skillName,
  skillScore,
  skillId,
  levelsetResults,
  onCloseUpdatedModal,
}: Props) => {
  return (
    <Fragment>
      <div
        css={{
          background: 'var(--cds-color-blue-950)',
          width: '100%',
          height: 200,
        }}
      >
        <ConfettiSVG side="left" />
        <ConfettiSVG side="right" />
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 'var(--cds-spacing-600)',
          }}
        >
          <Typography component="h1" color="invertBody" variant="d2semibold" css={{ order: 2 }}>
            {_t('LevelSet complete!')}
          </Typography>
          <Typography2
            component="h2"
            color="invertBody"
            variant="subtitleMedium"
            css={{ order: 1, textTransform: 'uppercase' }}
          >
            <FormattedMessage
              message={_t('{skillName} • Attempt {attemptNumber} of {totalAttempts} ')}
              skillName={skillName}
              attemptNumber={levelsetResults.attemptNumber}
              totalAttempts={levelsetResults.totalAttempts}
            />
          </Typography2>
        </div>
      </div>
      <div
        css={{
          border: `1.5px solid var(--cds-color-grey-50)`,
          borderRadius: 4,
          background: 'var(--cds-color-neutral-background-primary)',
          minHeight: 150,
          marginTop: -26,
          marginBottom: 'var(--cds-spacing-400)',
          width: `calc(100% - 2*var(--cds-spacing-400))`,
          [breakpoints.down('xs')]: {
            width: '100%',
            marginBottom: 0,
          },
        }}
      >
        <LevelSetsResultBody
          onCloseUpdatedModal={onCloseUpdatedModal}
          skillId={skillId}
          skillName={skillName}
          skillScore={skillScore}
          levelsetResults={levelsetResults}
          userId={userId}
        />
      </div>
    </Fragment>
  );
};

export default LevelSetsResultContent;
